import { inject, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { GraphqlService } from "../shared/services/graphql.service";
import { environment } from "@/src/environments/environment";

@Injectable({ providedIn: 'root' })
export class ReportService {
  private http = inject(HttpClient); 
  private graphqlService = inject(GraphqlService);

  constructor() {}

  progressStatusCount() {
    return this.http.post(`${environment.apiUrlLabelTraxxService}/generate-report`, {report: 'PROGRESS_STATUS_COUNT'});
  }

  getEoD(recordId: any) {
    const query = `{
      eod(id: "${recordId}") {
        id
        date
        tj
        tj_accepted
        tj_processing
        tj_rejected
        tj_canceled
        tj_complete
        tj_other
        intouch_complete_orders
        intouch_canceled_orders
        avery
        avery_accepted
        avery_ready
        avery_rejected
        avery_canceled
        avery_done
        avery_other
        avery_complete_orders
        avery_canceled_orders
        updatedAt
        createdAt
      }
    }`;

    const variables = { }; // Pass variables here
    return this.graphqlService.query(query, variables);
  }

  paginateEoDList(searchColumn: string, searchTerm: string, limit: number, startKey: string) {
    const variables = { param: searchColumn, value: searchTerm, limit: limit, startKey: startKey};
    const query = `query paginateEoDs($param: String, $value: String, $limit: Float, $startKey: String) {
      paginateEoDs(param: $param, value: $value, limit: $limit, startKey: $startKey) 
      {
        items {
          id
          date
          tj
          tj_accepted
          tj_processing
          tj_rejected
          tj_canceled
          tj_complete
          tj_other
          avery
          avery_accepted
          avery_ready
          avery_rejected
          avery_canceled
          avery_done
          avery_other
          updatedAt
          createdAt
        }
        lastKey
      }
    }`
    return this.graphqlService.query(query, variables);
  }

}